import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import UserGuide from "../pages/user-guide/page";
import SampleReports from "../pages/sample-reports/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/user-guide",
    element: <UserGuide />,
  },
  {
    path: "/sample-reports",
    element: <SampleReports />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
